import { z } from 'zod';

export const uuidSchema = z.string().uuid();
export const isoTimestampSchema = z.string().datetime({ offset: true });
export const dateOnlySchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Expected YYYY-MM-DD');

export const syncBookkeepingSchema = z.object({
  user_id: uuidSchema,
  created_at: isoTimestampSchema,
  updated_at: isoTimestampSchema,
  deleted_at: isoTimestampSchema.nullable(),
  row_version: z.union([z.number().int(), z.string()]),
});

export type SyncBookkeeping = z.infer<typeof syncBookkeepingSchema>;
